import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { deleteTaskAction } from '../../../../redux/tasks/actions';
import { isTicketOpen } from '../../../../actions';

const DeleteTaskMenuItem = ({ taskId }) => {
  const dispatch = useDispatch();
  const deletingRef = useRef(false);

  const handleDeleteTask = () => {
    if (deletingRef.current) return;
    deletingRef.current = true;
    dispatch(deleteTaskAction(taskId, () => { }));
    dispatch(isTicketOpen(false));
  };

  return (
    <div className='text-red-600 font-14' onClick={handleDeleteTask}>
      <FormattedMessage id="DELETE" defaultMessage="Delete" />
    </div>
  );
};

export default DeleteTaskMenuItem;
